import React, { memo } from 'react';

import AGGridCellRenderer from './AGGridCellRenderer';
import ClearCellButton from './ClearCellButton';
import { useCellStatus } from './UseCellStatusStore';
import { isEmptyCellValue } from '../shared';

import { FaCheckCircle } from 'react-icons/fa';
import { MdErrorOutline } from 'react-icons/md';

import Loader from 'v3/components/Loader';

import {
  StyledFleetCellContent,
  StyledStatusIcon,
  FleetCellSkeleton
} from './styles';

const FleetCellRenderer = memo((props) => {
  const key = `${props.data.id}:${props.colDef.field}`;

  const status = useCellStatus(key);

  if (props.data?.isSkeleton) {
    return (
      <StyledFleetCellContent>
        <FleetCellSkeleton />
      </StyledFleetCellContent>
    );
  }

  const isEditable =
    typeof props.colDef.editable === 'function'
      ? props.colDef.editable(props)
      : !!props.colDef.editable;

  const canClear = isEditable && !isEmptyCellValue(props.value) && typeof props.onClear === 'function';

  return (
    <StyledFleetCellContent>


      <div className="fleet-cell-content-value">
        <AGGridCellRenderer {...props} />
      </div>

      {canClear && (
        <ClearCellButton
          onClick={() => props.onClear(props.data.id, props.colDef.field, props.value, props.colDef.headerName)}
        />
      )}

      {status === 'pending' && (
        <Loader
          loading
          size="sm"
          className="fleet-cell-loader"
        />
      )}

      {status === 'success' && (
        <StyledStatusIcon $status="success">
          <FaCheckCircle />
        </StyledStatusIcon>
      )}

      {status === 'error' && (
        <StyledStatusIcon $status="error">
          <MdErrorOutline />
        </StyledStatusIcon>
      )}

    </StyledFleetCellContent>
  );
});

export default FleetCellRenderer;
